<template>
	<FieldWrapper v-bind="wrapper">
		<textarea ref="field" :id="name" :name="name" :type="type" v-model="model" />
	</FieldWrapper>
</template>

<script>
import FieldWrapper from '@/components/FieldWrapper'
import field from '@/mixins/field'

export default {
	name: 'FieldTextarea',
	mixins: [field],
	components: {
		FieldWrapper,
	},
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/components';

textarea {
	@extend %field;
	line-height: $line-height;
	padding: 0.75rem;
	resize: vertical;
	min-height: 6.125rem;
}
</style>
